import { render } from "./ServiciosEN.vue?vue&type=template&id=07b0d437&scoped=true"
import script from "./ServiciosEN.vue?vue&type=script&lang=js"
export * from "./ServiciosEN.vue?vue&type=script&lang=js"

import "./ServiciosEN.vue?vue&type=style&index=0&id=07b0d437&scoped=true&lang=css"
import "./ServiciosEN.vue?vue&type=style&index=1&id=07b0d437&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b0d437"]])

export default __exports__